/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { readOnly } from '@ember/object/computed';

import CampaignModel from 'cio/models/campaign';
import ActionModel from 'cio/models/action';

interface AudienceArgs {
  actionAbstract: {
    action: ActionModel;
    [key: string]: any;
  };
  isSaving: boolean;
  hasReadOnlyPermission: boolean;
}

export default class Audience extends Component<AudienceArgs> {
  @readOnly('args.actionAbstract.action.campaign') campaign!: CampaignModel;

  unsubscribedStates = [
    {
      label: 'Use campaign settings',
      value: null,
    },
    {
      label: 'Send even if unsubscribed',
      value: true,
    },
    {
      label: "Don't send to unsubscribed",
      value: false,
    },
  ];

  @action
  onChange(subscriptionTopicId: string | null, sendToUnsubscribed: boolean, useDefaultSettings?: boolean) {
    if (useDefaultSettings === true) {
      return this.defaultToCampaignSettings();
    }
    if (subscriptionTopicId === null) {
      return this.changeGlobalConfig(sendToUnsubscribed);
    }
    if (subscriptionTopicId) {
      return this.setSubscriptionTopic(subscriptionTopicId);
    }
  }

  private changeGlobalConfig(sendToUnsubscribed: boolean) {
    if (sendToUnsubscribed) {
      return this.sendToGloballyUnsubscribed();
    }
    return this.sendToGloballySubscribed();
  }

  private sendToGloballySubscribed() {
    this.args.actionAbstract.setProperties({
      subscriptionTopicId: null,
      sendToUnsubscribed: false,
    });
  }

  private sendToGloballyUnsubscribed() {
    this.args.actionAbstract.setProperties({
      subscriptionTopicId: null,
      sendToUnsubscribed: true,
    });
  }

  private setSubscriptionTopic(id: string) {
    this.args.actionAbstract.setProperties({
      subscriptionTopicId: id,
      sendToUnsubscribed: false,
    });
  }

  private defaultToCampaignSettings() {
    this.args.actionAbstract.setProperties({
      subscriptionTopicId: null,
      sendToUnsubscribed: null,
    });
  }
}
